/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashbackEdit_cashback$ref: FragmentReference;
declare export opaque type CashbackEdit_cashback$fragmentType: CashbackEdit_cashback$ref;
export type CashbackEdit_cashback = {|
  +id: string,
  +date: any,
  +place: string,
  +storeId: string,
  +rate: ?string,
  +amount: number,
  +$refType: CashbackEdit_cashback$ref,
|};
export type CashbackEdit_cashback$data = CashbackEdit_cashback;
export type CashbackEdit_cashback$key = {
  +$data?: CashbackEdit_cashback$data,
  +$fragmentRefs: CashbackEdit_cashback$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CashbackEdit_cashback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "place",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "type": "Cashback"
};
// prettier-ignore
(node/*: any*/).hash = '7ed93222209ceb1642fa8f34633a5fb7';

module.exports = node;
